<template>
    <modal :show-title="true" size="medium" @close="$emit('close', false)">
        <div slot="header">
            <h5 class="modal-title">{{$t('carrello_pag_carte')}}</h5>
        </div>
        <div slot="body" class="text-center">
            <form id="payment-form">
                <div class="form-row">
                    <label for="card-element">
                        {{$t('aggiungi_carta')}}
                    </label>
                    <div id="card-element">
                        <!-- A Stripe Element will be inserted here. -->
                    </div>

                    <!-- Used to display form errors. -->
                    <div id="card-errors" class="alert alert-danger mt-2 w-100" role="alert" v-if="this.error"
                         v-html="this.error">
                    </div>

                    <mcw-checkbox v-if="!this.hideSaveCard" v-model="form.save_payment_method">
                        {{$t("salva_carta")}}
                    </mcw-checkbox>
                </div>
            </form>
        </div>
        <div slot="footer" class="flex-fill text-center">
            <button type="button" class="btn btn-primary" @click="submit()"
                    :disabled="!this.completed || this.loading_visible">
                <span v-if="this.save">
                    {{$t('btn_salva')}}
                </span>
                <span v-else>
                    {{$t('btn_conferma')}}
                </span>
            </button>
        </div>
    </modal>
</template>

<script>
import {mapState} from 'vuex';

import Modal from './Modal';

export default {
    name: "ModalStripePayment",
    components: {Modal},
    props: ['stripe', 'save', 'hideSaveCard'],
    data() {
        return {
            card: null,
            completed: false,
            error: null,
            form: {
                save_payment_method: false,
            }
        }
    },
    mounted() {
        // Create an instance of Elements.
        const elements = this.stripe.elements({locale: this.language});

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        const style = {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element.
        this.card = elements.create('card', {style: style, hidePostalCode: true});

        // Add an instance of the card Element into the `card-element` <div>.
        this.card.mount('#card-element');

        this.card.on('change', (event) => {
            this.completed = false;
            this.error = null;
            if (event.complete) {
                this.completed = true;
            } else if (event.error) {
                this.error = event.error.message;
            }
        });
    },
    computed: {
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        })
    },
    methods: {
        submit: function () {
            this.$emit('onSubmit', this.card, this.form.save_payment_method);
        }
    }
}
</script>

<style scoped>
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
    box-sizing: border-box;

    height: 40px;
    width: 100%;

    padding: 10px 12px;

    border: 1px solid transparent;
    border-radius: 4px;
    background-color: white;

    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
}

.StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
    border-color: #fa755a;
}

.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
}
</style>
